import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/reports")({
  component: ReportsLayout,
});

function ReportsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "reports", actions: ["read"] }]}
    >
      <RouteGuard module="reports" action="read">
        <Outlet />
      </RouteGuard>
    </RouteGuardPermissions>
  );
}
